import React from 'react';

import { Paper } from '@material-ui/core';

import { UiDialog } from '../../ui/ui-dialog';

import { formatPhoneNumber } from '../../util/formatters';
import { getCustomerLogoPath } from '../../util/get-customer-logo-path';

type InputProps = {
  handleToggleDialog: () => void;
  name: string;
  phone: string;
  logo_path: string;
  org_key: string;
};

export const VCardDialog = ({
  handleToggleDialog,
  name,
  phone,
  logo_path,
  org_key,
}: InputProps) => (
  <UiDialog onClose={handleToggleDialog} size="xs" title="Contact Card Preview">
    <UiDialog.Content>
      <div className="u-textAlign-center u-margin-bottom-sm">
        Sending a contact card provides an easy way for an employee to save your contact information
        to their phone
      </div>
      <div className="typo-subtitle u-textAlign-center u-margin-bottom-lg">
        Recommended for introductory messages to new employees
      </div>
      <Paper className="u-width-300px u-padding-lg u-flexColumn u-margin-0Auto u-alignItems-center u-justifyContent-center">
        <img
          src={`${getCustomerLogoPath({ logo_path, org_key })}`}
          className="u-width-75px u-height-75px u-scaleDown u-borderRadius-50 u-border"
          alt={name}
        />
        <div className="type-h6 typo-bold u-margin">{name}</div>
        <div className="u-width-100 u-padding-sm u-padding-left-2x u-border-bottom u-border-top">
          Phone:{' '}
          <a href={`tel:+1${phone}`} className="u-margin-left-lg">
            +1 {formatPhoneNumber(phone)}
          </a>
        </div>
      </Paper>
    </UiDialog.Content>
  </UiDialog>
);
